import { MenuPpal } from './types/types.system';
import { userModule, test, menuOrders, MenuSearch, menuBill, menuReports, menuTrace, menuDashboard, menuCalendar, menuSettings, alert, menuAnalizaer, ExternalSystem, measurementsQC, menuRemExt, menuAboutSyner } from './images/icons';

export const navigation: MenuPpal[] = [
  {
    text: 'menuPpal',
    path: '/home',
    icon: menuDashboard,
    items: [],
  },
  {
    text: 'menuDate',
    path: '/adminAgendaCitas',
    icon: menuCalendar,
    permission: 'Prm_Citas',
    items: [],
    module: 'ModuleSchedule',
  },
  {
    text: 'menuPatient',
    path: '/patients',
    icon: userModule,
    permission: 'Prm_Pac',
    items: [],
    module: 'ModulePatients',
  },
  {
    text: 'menuOrders',
    path: '',
    icon: menuOrders,
    permission: 'Prm_Ord_R',
    items: [
      {
        text: 'menuAdminOrders',
        path: '/admin-orders',
        permission: 'Prm_Ord',
      },
      {
        text: 'menuPreOrders',
        path: '/preorders',
        permission: 'Prm_Preordenes',
      },
      {
        text: 'menuBarcodes',
        path: '/barcodes',
        permission: 'Prm_CodBarrras',
        module: 'ModuleBarcode',
      },
      {
        text: 'menuReferrals',
        path: '/referrals',
        permission: 'Prm_Ord_Remisiones_R',
        module: 'ModuleRemisions',
        fechaLanzamiento: '2025-06-20',
        fechaFin: '2025-07-30',
      },
      {
        text: 'menuMassValidation',
        path: '/mass-validation',
        permission: 'Prm_ResValMasivo',
        module: 'ModuleValidationMasive',
        fechaLanzamiento: '2025-06-20',
        fechaFin: '2025-07-30',
      },
    ],
  },
  {
    text: 'menuSamples',
    path: '',
    icon: test,
    module: 'ModuleSamples',
    permission: 'Prm_Ord_Tracking_R',
    items: [
      {
        text: 'menuTracking',
        path: '/tracking',
        permission: 'Prm_Ord_Tracking_R',
        module: 'ModuleTracking',
      },
      {
        text: 'menuSerumLibrary',
        path: '/serum-library',
        permission: 'Prm_Seroteca_R',
        fechaLanzamiento: '2025-06-15', // Ejemplo: submenu nuevo (muy reciente - 4 días)
        fechaFin: '2025-08-01',
      },
    ],
  },
  {
    text: 'menuSearches',
    path: '',
    icon: MenuSearch,
    module: 'ModuleSearches',
    permission: 'Prm_Busqueda',
    items: [
      {
        text: 'menuSearchesOrders',
        path: '/find-results',
        permission: 'Prm_BusquedaOrdenes',
      },
      {
        text: 'menuSearchesPatients',
        path: '/find-patient',
        permission: 'Prm_BusquedaPacientes',
      },
      {
        text: 'menuMassPrinting',
        path: '/mass-printing',
        permission: 'Prm_Imprimir',
        fechaLanzamiento: '2026-04-16',
        fechaFin: '2026-05-31',
      },
      {
        text: 'menuInformedConsents',
        path: '/informed-consents',
        permission: 'Prm_Ord_Consentimientos_R',
        module: 'ModuleInformedConsents',
        fechaLanzamiento: '2026-07-29',
        fechaFin: '2026-08-31',
      },
      // {
      //   text: 'menuMassValidation',
      //   path: '/mass-validation',
      //   permission: 'Prm_ResValidar',
      // },
      // {
      //   text: 'menuTimers',
      //   path: '/timers',
      //   permission: '',
      // },
    ],
  },
  {
    text: 'menuQC',
    path: '',
    icon: measurementsQC,
    // Sin 'permission' a proposito: quien decide si el laboratorio tiene control de calidad es
    // el MODULO, y lo que cada persona puede abrir lo deciden los permisos de cada hijo.
    //
    // Antes aqui habia permission: 'Prm_QC', un permiso paraguas que no usa ningun endpoint y
    // que no coincide con el de ningun hijo. Resultado: alguien con Prm_Config_QC —el permiso
    // que de verdad hace falta para configurar calidad— no veia el menu, porque le faltaba un
    // permiso que no otorga nada mas y que nadie tenia motivo para encender. El resto de los
    // grupos del menu no tienen ese problema porque su permiso coincide con el de un hijo
    // (menuSamples usa Prm_Ord_Tracking_R, el mismo de menuTracking).
    //
    // Un grupo que se quede sin hijos visibles no se pinta: de eso se encarga SideNavigationMenu.
    module: 'ModuleQC',
    items: [
      {
        text: 'menuConfigurationQC',
        path: '/config-qc',
        permission: 'Prm_Config_QC',
        fechaLanzamiento: '2026-01-01',
        fechaFin: '2026-01-31',
      },
      // {
      //   text: 'menuMeasurementsQC',
      //   path: '/measurements-qc',
      //   permission: 'Prm_QC_R',
      //   fechaLanzamiento: '2026-01-01',
      //   fechaFin: '2026-01-31',
      // },
      {
        text: 'menuMasiveMeasurementsQC',
        path: '/masive-measurements-qc',
        permission: 'Prm_QC_R',
        fechaLanzamiento: '2026-01-01',
        fechaFin: '2026-01-31',
      },
    ],
  },
  {
    text: 'menuBilling',
    path: '',
    icon: menuBill,
    items: [
      {
        text: 'menuQuotations',
        path: '/quotations',
        permission: 'Prm_Cotizaciones',
      },
      {
        text: 'menuCashier',
        path: '/cashier',
        permission: 'Prm_FactCaja',
      },
      {
        text: 'menuElectronicBilling',
        path: '/electronic-billing',
        permission: 'Prm_FacturacionMasiva',
      },
    ],
    permission: 'Prm_Fact',
    module: 'ModuleBilling',
  },
  {
    text: 'menuConections',
    path: '/conexiones',
    icon: ExternalSystem,
    permission: 'Prm_External',
    items: [],
  },
  {
    text: 'menuReports',
    path: '',
    icon: menuReports,
    permission: 'Prm_Inf',
    items: [
      {
        text: 'menuDashboards',
        path: '/dashboards',
        permission: 'Prm_Inf',
        fechaLanzamiento: '2026-07-29',
        fechaFin: '2026-08-31',
      },
      {
        text: 'menuReportsandstatistics',
        path: '/reports',
        permission: 'Prm_Inf',
      },
      {
        text: 'menuControlBoards',
        path: '/control-boards',
        permission: 'Prm_Inf',
      },
    ],
  },
  {
    text: 'menuExternalRemisions',
    path: '/external-remisions',
    icon: menuRemExt,
    permission: 'Prm_ExternalRem',
    module: 'ModuleExternalRemissions',
    items: [],
  },
  {
    text: 'menuAnalizers',
    path: '/analyzers',
    icon: menuAnalizaer,
    items: [],
    permission: 'Prm_Analizador',
    module: 'ModuleAnalyzers',
  },
  {
    text: 'menuTraceability',
    path: '',
    icon: menuTrace,
    items: [
      {
        text: 'menuTraceabilityOrders',
        path: '/traceability',
        permission: 'Prm_Monitoreo',
      },
      {
        text: 'menuTraceabilityMasive',
        path: '/traceability-masive-actions',
        permission: 'Prm_Monitoreo',
        fechaLanzamiento: '2026-04-26',
        fechaFin: '2026-05-31',
      },
    ],
    permission: 'Prm_Monitoreo',
  },
  {
    text: 'menuWarnings',
    path: '/warnings',
    icon: alert,
    items: [],
    permission: 'Prm_Alarmas_R',
    module: 'ModuleWarnings',
  },
  {
    text: 'menuConfiguration',
    path: '',
    icon: menuSettings,
    permission: 'Prm_Conf',
    items: [
      {
        text: 'menuConfigurationAgenda',
        path: '/configAgendaCitas',
        permission: 'Prm_Config_Citas',
      },
      // {
      //   text: 'menuConfigurationAlarmas',
      //   path: '/alarmas',
      // },
      {
        text: 'menuConfigurationAnalitos',
        path: '/analitos',
        permission: 'Prm_Conf_Analito',
      },
      {
        text: 'menuConfigurationAnalizadores',
        path: '/analizadores',
        permission: 'Prm_Conf_Manejo',
      },
      // {
      //   text: 'menuConfigurationCamposDinamicos',
      //   path: '/config-campos-dinamicos',
      // },
      {
        text: 'menuConfigurationConfigGeneral',
        path: '/config-general',
        permission: 'Prm_Conf_Manejo',
      },
      {
        text: 'menuConfigurationDefiniciones',
        path: '/config-reportes-definiciones',
        permission: 'Prm_Conf_Campos',
      },
      {
        text: 'menuConfigurationEstudios',
        path: '/estudios',
        permission: 'Prm_Conf_Estudio',
      },
      {
        text: 'menuConfigurationFacturacion',
        path: '/config-facturacion',
        permission: 'Prm_Config_Facturacion',
      },
      {
        text: 'menuConfigurationImpresoraCodBarras',
        path: '/configbarcodes',
        permission: 'Prm_Conf_Barcode_Imp',
      },
      {
        text: 'menuConfigurationEstudiosPerfiles',
        path: '/estudios-perfiles',
      },
      // {
      //   text: 'menuConfigurationPermisos',
      //   path: '/config-permisos',
      // },
      {
        text: 'menuConfigurationReportes',
        path: '/config-reportes',
        permission: 'Prm_Conf_Reportes',
      },
      // {
      //   text: 'menuConfigurationReportesInformes',
      //   path: '/config-reportes-informes',
      // },
      {
        text: 'menuConfigurationReportesInformesDisenador',
        path: '/config-reportes-disenador',
        permission: 'Prm_Conf_Reportes',
      },
      {
        text: 'menuConfigurationTablas',
        path: '/config-tablas',
        permission: 'Prm_ConfTablas',
      },
      {
        text: 'menuConfigWebPagePatients',
        path: '/config-web-page-patients',
        permission: 'Prm_PagWebRes_Config',
      },
      {
        text: 'menuConfigurationUsuarios',
        path: '/config-usuarios',
        permission: 'Prm_Conf_Usuario',
      },
      {
        text: 'menuConfigurationTareasOperativa',
        path: '/tareas-operativas',
        permission: 'Prm_Conf_Manejo',
      },
      {
        text: 'menuConfigurationNotes',
        path: '/config-notas',
        permission: 'Prm_ConfTablas',
      },
      {
        text: 'menuConfigurationEmailTemplates',
        path: '/config-email-templates',
        permission: 'Prm_ConfTablas',
      },
      {
        text: 'menuConfigInformedConsents',
        path: '/config-informed-consents',
        permission: 'Prm_Conf_Consentimientos',
        module: 'ModuleInformedConsents',
      },
      {
        text: 'menuConfigBackups',
        path: '/config-backups',
        permission: 'Prm_BackUp_R',
      },
      {
        text: 'menuConfigSqlEditor',
        path: '/sql-editor',
        permission: 'Prm_SqlEditor',
      },
    ],
  },
  {
    text: 'menuAboutSynerLab',
    path: '/about-syner-lab',
    icon: menuAboutSyner,
    items: [],
    fechaLanzamiento: '2026-04-26',
    fechaFin: '2026-05-31',
  },
];
